import type { SelectedBasketOption } from 'components/ordering/order-form/add-to-basket-api.js'

export class ProductQuantityChangedEvent extends Event {
  static type = 'product-quantity-changed' as const

  constructor(public productId: number, public quantity: number) {
    super(ProductQuantityChangedEvent.type, { bubbles: true, composed: true })
  }
}

export class ProductOptionsChangedEvent extends Event {
  static type = 'product-options-changed' as const

  constructor(public productId: number, public options: SelectedBasketOption[]) {
    super(ProductOptionsChangedEvent.type, { bubbles: true, composed: true })
  }
}

export class ProductSelectionRequestedEvent extends Event {
  static type = 'product-selection-requested' as const

  constructor(public productId: number) {
    super(ProductSelectionRequestedEvent.type, { bubbles: true, composed: true })
  }
}

declare global {
  interface GlobalEventHandlersEventMap {
    [ProductQuantityChangedEvent.type]: ProductQuantityChangedEvent,
    [ProductOptionsChangedEvent.type]: ProductOptionsChangedEvent,
    [ProductSelectionRequestedEvent.type]: ProductSelectionRequestedEvent,
  }
}
